
<template>
	<section>			
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>			
                <el-form-item  style="float:right;">
					<el-button size="width:100%; height:100%;"  type="primary" v-on:click="getListData" icon="el-icon-search">查询</el-button>
				</el-form-item>	
				<el-form-item  style="float:right;">
					<el-button type="primary" @click="handleAdd">添加公众号信息</el-button>
				</el-form-item>					
				<el-form-item>
					<el-input  v-model="filters.AppName"  @keyup.enter.native="getListData" placeholder="公众号名称"></el-input>
				</el-form-item>		
			</el-form>
		</el-col>

		<!--列表-->
<el-table   :data="List" highlight-current-row v-loading="listLoading"  style="width:1702px">
    <el-table-column type="expand" >
      <template slot-scope="props">
           <el-table  :data="props.row.ItemBinding">
          <el-table-column prop="ShopName" label="门店名称" width="220"  sortable>             
          </el-table-column>
			<el-table-column prop="LinkMan" label="联系人" width="120"  sortable>
			</el-table-column>          
           	<el-table-column prop="Mobile" label="手机号码" width="150"  sortable>
			</el-table-column>	           
           	<el-table-column prop="Tel" label="电话号码" width="150"  sortable>
			</el-table-column>
           	<el-table-column prop="CreationTime" label="创建世界" width="150"  sortable>
			</el-table-column>			
			<el-table-column prop="Remark" label="备注" min-width="100" sortable>
			</el-table-column>  
			<el-table-column  label="操作" min-width="240" fixed="right"  sortable>
					<template slot-scope="scope" >
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">解除绑定</el-button>						
                    </template> 
			</el-table-column>  			          
            </el-table>
			<el-col :span="24" class="toolbar">
			<el-tag>当前有{{props.row.ItemBinding.length}}个绑定门店</el-tag>
		    </el-col>
     </template>
           </el-table-column>           
			<el-table-column  label="分享二维码" width="140" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img v-if="scope.row.QRcodeUrl!=null"  @click="see(scope.row.QRcodeUrl)"  :src="scope.row.QRcodeUrl" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
			</template>				
			</el-table-column>	
			<el-table-column  label="公众号二维码" width="150" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img v-if="scope.row.ImageUrlStr!=null"  @click="see(scope.row.ImageUrlStr)"  :src="scope.row.ImageUrlStr" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
			</template>				
			</el-table-column>	
			<el-table-column prop="InternalCode" label="内码" width="170" sortable>
			</el-table-column>			
			<el-table-column prop="AppName" label="公众号名称" width="170" sortable>
			</el-table-column>
			<el-table-column prop="Appid" label="Appid" width="200"  sortable>
			</el-table-column>	           
           	<el-table-column prop="Secretkey" label="密钥" width="200"  sortable>
			</el-table-column>		
           	<el-table-column prop="CreationTime" label="创建时间" width="180"  sortable>
			</el-table-column> 
 			  <!-- <el-table-column prop="State" label="评价进度" width="120" >				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="warning" size="medium" v-if="scope.row.State=='2'">等待学员评价</el-tag>
                  <el-tag type="info" size="medium" v-if="scope.row.State=='0'">等待教练评价</el-tag>
                   <el-tag type="success" size="medium" v-if="scope.row.State=='3'">评价已完成</el-tag>
                  </div>
                  </template>
			</el-table-column>            -->
 			  <el-table-column prop="State" label="状态" width="120" >				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="info" size="medium" v-if="scope.row.State=='1'">停用</el-tag>
                  <el-tag type="success" size="medium" v-if="scope.row.State=='0'">启用</el-tag>
                  </div>
                  </template>
			</el-table-column> 
 			  <el-table-column prop="ActivationState" label="是否激活" width="120" >				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="success" size="medium" v-if="scope.row.ActivationState=='1'">是</el-tag>
                  <el-tag type="info" size="medium" v-if="scope.row.ActivationState=='0'">否</el-tag>
                  </div>
                  </template>
			</el-table-column>			 			
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>  
			<el-table-column  label="激活状态" width="120" sortable fixed="right">
				<template slot-scope="scope">			
				<el-switch :ref="List[scope.$index].Id"   v-model="List[scope.$index].ActivationState==1?true:false" active-color="#13ce66" inactive-color="#ff4949" @change="ChangeActivation(scope.row,scope.row.Id)" :disabled="false"></el-switch>
				 </template>
			</el-table-column>	
			<el-table-column  label="变更状态" width="120" sortable fixed="right">
				<template slot-scope="scope">			
				<el-switch :ref="List[scope.$index].Id"   v-model="List[scope.$index].State==1?false:true" active-color="#13ce66" inactive-color="#ff4949" @change="Change(scope.row,scope.row.Id)" :disabled="false"></el-switch>
				 </template>
			</el-table-column>							       
			<el-table-column label="操作" min-width="400" fixed="right">
				<template  slot-scope="scope">
					<el-button size="small" type="primary" @click="imageShow(scope.$index, scope.row)">上传公众号二维码</el-button>                   
					<el-button type="primary" size="small" @click="Generate(scope.row)">生成分享码</el-button>
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="warning" size="small" @click="handleAddBinding(scope.row)">添加绑定</el-button>
				</template>
			</el-table-column>
</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-tag>当前有{{Count}}个公众号</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		<el-dialog title="查看大图" v-model="seeImageVisible">
					<div style="width:100%;margin:0 auto; text-align:center;"><img   :src="imgUrl" style=" background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; "></div>
		</el-dialog>
		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
				<el-form-item label="公众号名称" prop="AppName">
					<el-input v-model="editForm.AppName" auto-complete="off"></el-input>
				</el-form-item>	                
 				<!-- <el-form-item label="Appid" prop="Appid">
					<el-input v-model="editForm.Appid" auto-complete="off"></el-input>
				</el-form-item>               
				<el-form-item label="密钥" prop="Secretkey">
					<el-input v-model="editForm.Secretkey" auto-complete="off"></el-input>
				</el-form-item>								 -->
				<el-form-item label="备注">
					<el-input type="textarea" v-model="editForm.Remark"></el-input>
				</el-form-item>			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
		<!--新增界面-->
		<el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false">
			<div v-show="div1">
			<el-col :span="24">
			<el-form  label-width="100px">            
 				<el-form-item label="Appid" prop="AppidValue">
					<el-input v-model="AppidValue" auto-complete="off" placeholder="请输入公众号appid"></el-input>
				</el-form-item>               		
			</el-form>
			<div  style="float:right">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="checkSignData" :loading="addLoading">查询公众号</el-button>
			</div>	
			<br>
				<br>
					<br>
			</el-col>
			
			</div>
			<div v-show="div2">
			<el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
				<!-- <el-form-item label="内码" prop="InternalCode">
					<el-input v-model="addForm.InternalCode" auto-complete="off"></el-input>
				</el-form-item>	 				 -->
				<el-form-item label="公众号名称" prop="AppName">
					<el-input disabled v-model="addForm.AppName" auto-complete="off"></el-input>
				</el-form-item>	                
 				<el-form-item label="Appid" prop="Appid">
					<el-input disabled v-model="addForm.Appid" auto-complete="off"></el-input>
				</el-form-item>               
				<!-- <el-form-item label="密钥" prop="Secretkey">
					<el-input v-model="addForm.Secretkey" auto-complete="off"></el-input>
				</el-form-item>												 -->
				<el-form-item label="备注">
					<el-input type="textarea" v-model="addForm.Remark"></el-input>
				</el-form-item>			
			</el-form>
			<div style="float:right">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
				<br>
				<br>
			</div>

		</el-dialog>

		<el-dialog title="绑定门店" v-model="bindingFormVisible" :close-on-click-modal="false" style="width:60%;margin: 0 auto;padding-top: 0px;padding-right: 0.25em;padding-bottom: 2ex;padding-left: 0px;">
			<el-form :model="bindingForm" label-width="100px"  ref="addbindingForm">

			<template>
               <el-transfer filterable :titles="['门店列表', '绑定列表']" v-model="value1" :data="data"></el-transfer>
           </template>
		   	</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="bindingFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addBinding" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

         <el-dialog id="tt" title="上传" v-model="uploadimageVisible" >
             <el-upload
              class="upload-demo"
              drag action=""
              :http-request="upload"
              multiple customClass=".el-upload-dragger">
             <i class="el-icon-upload"></i>
             <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
             <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload>
		</el-dialog>	
  <!-- 重置界面 -->
	</section>
</template>

<script>
	import util from '../../common/js/util'

	//import NProgress from 'nprogress'
	import {AccountUploadImage,GetSignData,GenerateQRcode,WeChatOfficialAccountChangeState,ChangeActivationState,getWeChatOfficialBinding,addWeChatOfficialBinding, GetBindingList , getWeChatOfficialAccountList, removeWeChatOfficialBinding, addWeChatOfficialAccount,editWeChatOfficialAccount  } from '../../api/api';

	export default {
		data() {
			
			return {
				accountId:"",
				uploadimageVisible:false,
				AppidValue:'',
				div1:false,
				div2:false,
				seeImageVisible:false,
				imgUrl:'',
				bindingForm:{
					WeChatOfficialId:'',
					ShopId:[]
				},
				bindingFormVisible:false,
				data:[],
				value1:[],
				filters: {
					AppName:'',			
				},
				fit:'contain',
				coachId:'',
				Count:0,
				List:[],
				total: 0,
				page: 0,
				listLoading: false,
				sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					AppName: [
						{ required: true, message: '请输入公众号名称', trigger: 'blur' }
                    ],	
					// Secretkey: [
					// 	{ required: true, message: '请输入公众号密钥', trigger: 'blur' }
                    // ],					
                    		
 					// Appid: [
                    //     { required: true, message: '请输入Appid'},
                    // ],             
				},
				//编辑界面数据
				editForm: {
					AppName: '',
					Appid:10,
					Secretkey:2,
					Remark:'',
				},
				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					AppName: [
						{ required: true, message: '请输入公众号名称', trigger: 'blur' }
                    ],	   
					// InternalCode: [
					// 	{ required: true, message: '请输入内码', trigger: 'blur' }
                    // ],
					Appid: [
						{ required: true, message: '请输入Appid', trigger: 'blur' }
                    ],	 						 
					                                    
				},
				//新增界面数据
				addForm: {
					InternalCode:'',
					AppName: '',
					Appid:10,
					Secretkey:2,
					Remark:'',				
				},
				optionsShop:[],
			}
		},
		methods: {
 		imageShow(index,row)
			{
				this.accountId=row.Id;
			// console.log("111"+upload);
			  this.uploadimageVisible=true;
			  
			},    			
 		upload(param)
			{
			    var fileObj=param.file;
			    console.log(param);
				var fd=new FormData();
				fd.append("file",fileObj);
				fd.append("Id",this.accountId);
			  	AccountUploadImage(fd).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '上传成功',
							type: 'success'
						});
						this.getListData();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}		              
			  }).catch(error=>{
                 alert('网络错误');
                });
			},           			
			checkSignData(){
				if(this.AppidValue=='')
				{
                                   this.$message({
									message: '请输入appid',
									type: 'error'
								});	
								return;				
				}

				let para={
						appid:this.AppidValue,				
				}
              GetSignData(para).then((res)=>{	
								let { Success,Msg } = res.data;
								console.log(Success);
								if(Success)
								{
                                    // this.$message({
									// message: Msg,
									// type: 'success'
									// });	
									this.addForm.AppName=res.data.Data.AppName;
									this.addForm.Appid=res.data.Data.Appid;
									 this.div2=true;		
									 this.div1=false;														
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
							     	});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '公众号检查失败',
					    type: 'error'
					 });	
				});					

			},
			Generate(row){
				let para={
						id:row.Id,				
				}
              GenerateQRcode(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});	
									row.QRcodeUrl=res.data.Data;								
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '生成失败',
					    type: 'error'
					 });	
				});				
			},
 			see(Image){
                     this.imgUrl=Image;
                  this.seeImageVisible=true;
              },   			
		ChangeActivation(row,index)
			{
				let para={
						id:index,				
				}
              ChangeActivationState(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									row.ActivationState=res.data.Data;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});
			},            					
		Change(row,index)
			{
				let para={
						id:index,				
				}
              WeChatOfficialAccountChangeState(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									row.State=res.data.Data;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});
			},            			
			expand(row, expandedRows){
				console.log("tttt");
			},
          getShopList()
           {
            let para={}
            GetBindingList(para).then((res) => {                  
					this.optionsShop = res.data;
				 this.data=[];
                this.optionsShop.forEach((item) => {
					// console.log(item);
                   this.data.push({
                    label:item.Name,
					 key: item.Id,
					 disabled:false
                    });
                  });
				})
				 .catch(error=>{
                 alert('网络错误');
                });          				
           },   			
		handleAddBinding(row){

			this.bindingForm.WeChatOfficialId=row.Id;
			this.bindingForm.ShopId=[];
			this.value1=[];						
			   this.bindingFormVisible=true;

			this.getShopList();
			   
			},        
						//性别显示转换
			// formatSex: function (row, column) {
			// 	return row.Sex == 1 ? '男' : row.Sex == 0 ? '女' : '未知';
			// },
			// formatType: function (row, column) {
			// 	return row.Type == 1 ? '学员考察维度' :  '教练考察维度' ;
			// },

			// formatDate: function (row, column) {
			// 	return util.formatDate.format(new Date(row.Birthday), 'yyyy-MM-dd');
			// },
			// formatState: function (row, column) {
			// 	return row.State == 1 ? '暂停' : row.State == 0 ? '启用' : '未知';
			// },
			//性别显示转换
			handleCurrentChange(val) {
				this.page = val;
				this.getListData();
			},

			getListData() {
				// this.getCount();
				let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					AppName:this.filters.AppName,
				};
				this.listLoading = true;
				//NProgress.start();
				getWeChatOfficialAccountList(para).then((res) => {
					//在浏览器打印出来可以看到 返回的信息应该怎么点
	
					//结合vsapi写法
					// this.total = res.data.total;
					// this.users = res.data.data;
					//前端mock测试
					this.total = res.data.TotleCount;
					this.List =res.data.Data;
                    this.Count=res.data.TotleCount;
					this.listLoading = false;
					console.log(res);
					//NProgress.done();
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},	
			getBindingItem(Value){
					let para = { WeChatOfficialId: Value				   
					};
					let list=[];
					getWeChatOfficialBinding(para).then((res) => {
						this.List.forEach(element => {
						 if(element.Id==Value)
						 {
							element.ItemBinding=res.data;
						 }
					 });						 
					});			
			},						
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { id: row.Id 					   
					};
					removeWeChatOfficialBinding(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getBindingItem(row.WeChatOfficialId);
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
					});
				}).catch(() => {
				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);

			},
			//显示新增界面
			handleAdd: function () {
				this.div1=true;	
                this.div2=false;
				this.addFormVisible = true;

			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {

							this.editLoading = true;
							let para = Object.assign({}, this.editForm);
							editWeChatOfficialAccount(para).then((res) => {
								this.editLoading = false;
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}
								
								this.$refs['editForm'].resetFields();
								this.editFormVisible = false;
								this.getListData();
							});
						});
					}
				});
			},
			addBinding: function () {
				this.$refs.addbindingForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							// console.log(this.value1);
							
							 this.bindingForm.ShopId=this.value1;
							 console.log(this.bindingForm.ShopId);
							 if(this.bindingForm.ShopId.length<1)
							 {
	                            this.$message({
									message: '请先添加绑定列表内容',
									type: 'error'
								});	
								return;						 
							 }
							 this.addLoading = true;
							let para= Object.assign({}, this.bindingForm);							
							addWeChatOfficialBinding(para).then((res) => {							
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								this.addLoading = false;
								this.bindingFormVisible = false;
								this.getBindingItem(this.bindingForm.WeChatOfficialId);
								// this.getListData();
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								this.addLoading = false;
								
								}
							}) .catch(error=>{
                            alert('系统错误');
                            });														
						});
					}
				});
			},			
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							// if(!(/^1[3456789]\d{9}$/.test(this.addForm.Phone)))
							//  {
                            //     this.$message({
							// 		message: '手机号码不正确',
							// 		type: 'error'
							// 	});
                            //    return ;
							//  }
							this.addLoading = true;
							let para= Object.assign({}, this.addForm);							
							addWeChatOfficialAccount(para).then((res) => {							
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								this.addLoading = false;
								this.addFormVisible = false;
								this.getListData();
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								this.addLoading = false;
								
								}
							}) .catch(error=>{
                            alert('系统错误');
                            });														
						});
					}
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},

   closeDialog(){
		this.inputIdCard="";
      this.onCellClick(event);
    },
   onCellClick(event)
   {
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
		},
		mounted() {
			this.getListData();
			// this.getShopList();
			// this.getCount();
		}
	}

</script>

<style scoped>
 /* .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    } */
.customWidth{
        width:22%;
    }
.el-dialog {
    position: absolute;
    left: 50%;
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    background: #fff;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-sizing: border-box;
    margin-bottom: 50px;
}
	.el-input__inner {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
	width: 300px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.el-upload-dragger {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 100%;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// WeChatOfficialAccount.vue?7b58d2f2